<script>
	import { getContext, createEventDispatcher } from 'svelte'
	import { styles } from '../library/scripts/styles.js'
	import Spinner from '../library/ShadersAndSpinners/SpinnerCircle.svelte'

	export let message1 = 'here the error message'
	export let message2 = 'second line'
	export let showOkButton = true
	export let spinner = false
	export let spinnerInfo = 'update'
	export let alertMessage = 'Alert message'

	let showSpinner = false

	const globals = getContext('globals')
	const colorError = globals.colorError
	const colorMain = globals.colorMain
	const fsS = globals.fsS
	const fsXS = globals.fsXS
	const hoverBg = globals.buttonBgHover

	let dispatch = new createEventDispatcher()

	const send_ok = async () => {
		if (spinner === 'true') showSpinner = true
		dispatch('alertok')
	}
	const send_abort = () => {
		showSpinner = false
		dispatch('alertclose')
	}
</script>

<main>
	<div class="title" use:styles={{ colorError, fsS }}>{alertMessage}</div>
	{#if !showSpinner}
		<div class="message" use:styles={{ colorMain, fsS }}>{message1}</div>
		<div class="message" style="color:{colorError} " use:styles={{ colorMain, fsS }}>{message2}</div>
	{/if}

	{#if spinner && showSpinner}
		<div class="spinner">
			<Spinner color="hsl(0,0%,60%)" size={fsS} fontSize={fsXS} info={spinnerInfo} />
		</div>
	{/if}

	<div class="buttonContainer">
		{#if showOkButton}
			<button use:styles={{ colorMain, fsXS, hoverBg }} on:click={send_ok}>ok</button>
		{/if}

		<button use:styles={{ colorMain, fsXS, hoverBg }} on:click={send_abort}>cancel</button>
	</div>
</main>

<style>
	main {
		position: relative;
		display: flex;
		flex-direction: column;
		width: clamp(280px, 32vw, 500px);
		height: 200px;
		margin: 2%;
		align-items: center;
		border: 1px solid white;
	}

	button {
		outline: none;
		padding: 5px;
		margin: 0;
		border: 1px solid green;
		border-radius: 5px;
		background-color: transparent;
		color: var(--colorMain);
		font-size: var(--fsXS);
		height: 25px;
		margin-left: 10px;
		cursor: pointer;
	}

	button:hover {
		background-color: var(--hoverBg);
	}

	.title {
		display: flex;
		justify-content: center;
		width: 100%;
		padding: 10px;
		border-bottom: 1px solid white;
		color: var(--colorError);
		font-size: var(--fsXSX);
	}

	.message {
		padding-top: 20px;
		color: var(--colorMain);
		font-size: var(--fsS);
		text-align: center;
	}

	.spinner {
		margin-top: 30px;
	}

	.buttonContainer {
		position: absolute;
		bottom: 15px;
		right: 15px;
		display: flex;
		justify-content: flex-end;
		width: 100%;
	}
</style>
